import React, {Component} from 'react';
import {Modal,Button,FormGroup,ControlLabel,FormControl} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
import {connect} from 'react-redux'
class RemarkRecordModal extends Component {

    constructor(props) {
      super(props)
      
      this.state = ({remark:'',errorMsg:'',showModal:false,docName:'',docNo:'',docTag:''})
    }

    componentDidMount(){
      if(this.props.onRef!==undefined){
        this.props.onRef(this)
      }
    }

  
    onShow(showModal=true,params={}){
      this.setState(Object.assign({showModal:showModal},params))
    }

    onHide(){
      if(this.props.onHide!==undefined){
        this.props.onHide()
      }else{
        this.onShow(false)
      }
    }

    onSaveClick(e) {
      let {docName,docNo,docTag,docMulti,isRequire,messages} = this.props
      if(this.props.onHide===undefined){
        docName = this.state.docName
        docNo = this.state.docNo
        docTag = this.state.docTag
      }

      if(this.state.remark=='' && isRequire){
        this.setState({errorMsg:'* '+messages['Please Give Reason']+'...'})
        return;
      }

      let postData = {doc_name:docName,doc_no:docNo,doc_tag:docTag,remark:this.state.remark}
      if (docMulti) {
        postData = Object.assign(postData,{multi_doc:true})        
      }
      
      WorkdocStore.saveRemarkRecord(postData,(result)=> {
        if (result.status==='OK') {
          this.setState({remark:'',showModal:false})
          if(this.props.onSuccess!==undefined)
            this.props.onSuccess(postData,result)
        }
      })
    }

    onModalClose(e) {
      this.setState({remark:''})
      if(this.props.onModalClose!==undefined)
        this.props.onModalClose()
      else{
        this.onHide()
      }
    }

    onTextChange(e) {
      this.setState({remark:e.target.value,errorMsg:''})
    }

    render(){
      let {show,docTitle,messages} = this.props
      let showModal = this.props.onHide!==undefined?show:this.state.showModal
      if(this.props.onHide===undefined){
        docTitle = this.state.docTitle
      }
      return (
        <Modal show={showModal} onHide={this.onHide.bind(this)}>
          <Modal.Header>
            {docTitle}
          </Modal.Header>          
          <Modal.Body>
            <FormGroup>
              <ControlLabel>{messages['Note/Reason']}</ControlLabel>
              <FormControl value={this.state.remark} onChange={this.onTextChange.bind(this)} />
            </FormGroup>
            <ControlLabel className='text-red'>{this.state.errorMsg}</ControlLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/>&nbsp;{messages['Save']}</Button>
            <Button onClick={this.onModalClose.bind(this)}><FontAwesome name='remove'/>&nbsp;{messages['Cancel']}</Button>
          </Modal.Footer>
        </Modal>
      )
    }
}

RemarkRecordModal.defaultProps = {
  show: true,  
  onHide: undefined,  
  docName: 'taxinvoice',
  docNo: '',
  docTitle: 'เปลี่ยนแปลงสถานะบิล',
  docTag: 'status',
  docMulti: false,
  isRequire:false
}
export default connect(
  (state) => ({messages: state.message.component.element.RemarkRecordModal}),null,null,{withRef:true},
)(RemarkRecordModal);


// WEBPACK FOOTER //
// ./src/component/element/RemarkRecordModal.js